"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NZ_DEMOGRAPHICS = exports.GEO = void 0;
var question_1 = require("../../utils/question");
var types_1 = require("../types");
var common_1 = require("./common");
var GEO = function (t, languages, settings) {
    var value = types_1.DYNATA_QVALUE.GEO_NZ;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        { value: '1', label: 'Auckland' },
        { value: '2', label: 'Bay of Plenty' },
        { value: '3', label: 'Canterbury' },
        { value: '4', label: 'Gisborne' },
        { value: '5', label: "Hawke's Bay" },
        { value: '6', label: 'Manawatu-Wanganui' },
        { value: '7', label: 'Marlborough' },
        { value: '8', label: 'Nelson' },
        { value: '9', label: 'Northland' },
        { value: '10', label: 'Otago' },
        { value: '11', label: 'Southland' },
        { value: '12', label: 'Taranaki' },
        { value: '14', label: 'Tasman' },
        { value: '15', label: 'Waikato' },
        { value: '16', label: 'Wellington' },
        { value: '17', label: 'West Coast' },
        { value: '99', label: 'Chatham Islands' },
        { value: '25064601', label: 'Niue' }
    ];
    return __assign(__assign({}, (0, common_1.getDefaultQuestion)(t, languages, translateKey, 'GEO - New Zealand Region', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts), { geo: 'area' })), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.GEO = GEO;
var NZ_DEMOGRAPHICS = function (t, languages, settings) { return [
    (0, common_1.GENDER)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.NZ, settings),
    (0, common_1.LANGUAGE_FLUENCY)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.NZ, settings),
    (0, common_1.FINANCIAL_PRODUCT)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.NZ, settings),
    (0, common_1.HOUSEHOLD_CHILDREN)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.NZ, settings),
    (0, common_1.VEHICLES_IN_HOUSEHOLD)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.NZ, settings),
    (0, common_1.EMPLOYMENT_STATUS)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.NZ, settings),
    (0, common_1.PETS_IN_HOUSEHOLD)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.NZ, settings),
    (0, common_1.NUMBER_OF_CHILDREN)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.NZ, settings),
    (0, common_1.PRIMARY_VEHICLES)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.NZ, settings),
    (0, common_1.HOME_TYPE)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.NZ, settings),
    (0, common_1.NUMBER_PPL_IN_HOUSEHOLD)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.NZ, settings),
    (0, exports.GEO)(t, languages, settings),
    (0, common_1.HOUSEHOLD_GROSS_INCOME)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.NZ, settings),
    (0, common_1.MARTIAL_STATUS)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.NZ, settings),
    (0, common_1.EDUCATION)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.NZ, settings),
    (0, common_1.AGE)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.NZ, settings)
]; };
exports.NZ_DEMOGRAPHICS = NZ_DEMOGRAPHICS;
//# sourceMappingURL=NZ.js.map